/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalDetailedCoverSheet } from './PalDetailedCoverSheet';
import {
    PalDetailedCoverSheetFromJSON,
    PalDetailedCoverSheetFromJSONTyped,
    PalDetailedCoverSheetToJSON,
    PalDetailedCoverSheetToJSONTyped,
} from './PalDetailedCoverSheet';
import type { GetPalDetailedCoverSheetResponsePhysiciansInner } from './GetPalDetailedCoverSheetResponsePhysiciansInner';
import {
    GetPalDetailedCoverSheetResponsePhysiciansInnerFromJSON,
    GetPalDetailedCoverSheetResponsePhysiciansInnerFromJSONTyped,
    GetPalDetailedCoverSheetResponsePhysiciansInnerToJSON,
    GetPalDetailedCoverSheetResponsePhysiciansInnerToJSONTyped,
} from './GetPalDetailedCoverSheetResponsePhysiciansInner';

/**
 * 
 * @export
 * @interface GetPalDetailedCoverSheetResponse
 */
export interface GetPalDetailedCoverSheetResponse {
    /**
     * 
     */
    cover_sheet: PalDetailedCoverSheet;
    /**
     * 
     */
    physicians: Array<GetPalDetailedCoverSheetResponsePhysiciansInner>;
    /**
     * 
     */
    has_carve_outs: boolean;
}

/**
 * Check if a given object implements the GetPalDetailedCoverSheetResponse interface.
 */
export function instanceOfGetPalDetailedCoverSheetResponse(value: object): value is GetPalDetailedCoverSheetResponse {
    if (!('cover_sheet' in value) || value['cover_sheet'] === undefined) return false;
    if (!('physicians' in value) || value['physicians'] === undefined) return false;
    if (!('has_carve_outs' in value) || value['has_carve_outs'] === undefined) return false;
    return true;
}

export function GetPalDetailedCoverSheetResponseFromJSON(json: any): GetPalDetailedCoverSheetResponse {
    return GetPalDetailedCoverSheetResponseFromJSONTyped(json, false);
}

export function GetPalDetailedCoverSheetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPalDetailedCoverSheetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cover_sheet': PalDetailedCoverSheetFromJSON(json['cover_sheet']),
        'physicians': ((json['physicians'] as Array<any>).map(GetPalDetailedCoverSheetResponsePhysiciansInnerFromJSON)),
        'has_carve_outs': json['has_carve_outs'],
    };
}

export function GetPalDetailedCoverSheetResponseToJSON(json: any): GetPalDetailedCoverSheetResponse {
    return GetPalDetailedCoverSheetResponseToJSONTyped(json, false);
}

export function GetPalDetailedCoverSheetResponseToJSONTyped(value?: GetPalDetailedCoverSheetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cover_sheet': PalDetailedCoverSheetToJSON(value['cover_sheet']),
        'physicians': ((value['physicians'] as Array<any>).map(GetPalDetailedCoverSheetResponsePhysiciansInnerToJSON)),
        'has_carve_outs': value['has_carve_outs'],
    };
}

